import {listener} from "../../../../../modules/vegas/js/util";
import axios from "axios";

listener('click', '.photogallery .btn-load-photogallery', (el, event) => {
	let page = parseInt(el.dataset.page);
	let route = el.dataset.route;

	el.dataset.page = page + 1;

	axios.get(route, {
		params: {page: page}
	}).then((response) => {
		if (response.data.view) {
			document.querySelector('.photos-container')
				?.insertAdjacentHTML('beforeend', response.data.view)
		}

		if (!response.data.more) {
			el.classList.add('d-none');
		}
	})
});
